export const APP_DATA_KEYS = {
    ACTIVE_CART: "ACTIVE_CART",
    PICKLIST: "PICKLIST",
    WORKFLOW: "WORKFLOW"
};

class AppData {

    save(key, value) {
        if (value == null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }

    remove(key) {
        localStorage.removeItem(key);
    }

    get(key) {
        const value = localStorage.getItem(key);
        try {
            return JSON.parse(value);
        } catch (e) {
            console.log(`error while parsing data for ${key} with value ${value}`);
            return null;
        }
    }

    saveActiveCart(cart) {
        this.save(APP_DATA_KEYS.ACTIVE_CART, cart);
    }

    getActiveCart() {
        return this.get(APP_DATA_KEYS.ACTIVE_CART);
    }

    savePicklist(picklist) {
        this.save(APP_DATA_KEYS.PICKLIST, picklist);
    }

    getPicklist() {
        return this.get(APP_DATA_KEYS.PICKLIST);
    }

    saveWorkflow(workflow) {
        this.save(APP_DATA_KEYS.WORKFLOW, workflow);
    }

    getWorkflow() {
        return this.get(APP_DATA_KEYS.WORKFLOW);
    }

}

const AppDataStore = new AppData();

export default AppDataStore;


// WEBPACK FOOTER //
// ./src/app-data.js